function TablePlaceholder(props) {
    const {columns} = props;

    const TableRowPlaceholder = () => {
        let tableRows = [];

        for (let i = 0; i < columns; i++) {
            tableRows.push(<td key={i}>
                <div className={"px-4 py-3 grid grid-flow-row gap-2 h-20"}>
                    <div className='h-6 bg-gray-200 rounded w-2/4'/>
                </div>
            </td>)
        }

        return <tr className='animate-pulse'>{tableRows}</tr>;
    }

    return (
        <>
            <TableRowPlaceholder/>
            <TableRowPlaceholder/>
            <TableRowPlaceholder/>
            <TableRowPlaceholder/>
            <TableRowPlaceholder/>
        </>
    );
}

export default TablePlaceholder;
